import { DEBUG } from "../../config";

function nilLog(message?: any, ...optionalParams: any[]) {
    // pass
}

export const debug = {
    log: DEBUG ? console.log.bind(console) : nilLog,
    error: DEBUG ? console.error.bind(console) : nilLog
};
